module.exports = __webpack_public_path__ + "img/ring_r_s_0_0@2x.a4f6b19b.png";